/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { loopFinancialsResponseSchema } from './loopFinancialsResponseSchema';

export const loopFinancialsByLoopIdsResponseSchema = z.object({
  get data() {
    return z
      .array(loopFinancialsResponseSchema)
      .describe('Financial summaries for requested loops');
  },
});
